import { isMobile } from './isMobile.mjs';
function canUploadSameBuffer() {
  return !isMobile.apple.device;
}
export { canUploadSameBuffer };